const env = (key, fallback = '') => import.meta.env[key] || fallback;

const configuredPhone = env('VITE_CLINIC_PHONE', '077069 60077');
const configuredWhatsapp = env('VITE_CLINIC_WHATSAPP', '917706960077');
const configuredEmail = env('VITE_CLINIC_EMAIL', 'mashdreams33@gmail.com');
const configuredCity = env('VITE_CLINIC_CITY', 'Varanasi');
const configuredRegion = env('VITE_CLINIC_REGION', 'Uttar Pradesh');
const configuredCountry = env('VITE_CLINIC_COUNTRY', 'IN');
const configuredMapUrl = env('VITE_GOOGLE_MAPS_URL', 'https://maps.app.goo.gl/FW4KePpZcJVzcMNk9');
const configuredGmbUrl = env('VITE_GOOGLE_BUSINESS_PROFILE_URL', 'https://share.google/VsWJEjQpWRGpKBqG4');
const configuredPostcode = env('VITE_CLINIC_POSTCODE', '221005');
const configuredAddress = env(
  'VITE_CLINIC_ADDRESS',
  'B.1/3, H-20, V.D.A. Flats, Ravindrapuri Extension, Near Oriana Hospital, Varanasi - 221005'
);
const configuredWhatsappHref = configuredWhatsapp ? `https://wa.me/${configuredWhatsapp.replace(/[^\d]/g, '')}` : '#booking';
const defaultMapEmbedUrl =
  'https://www.openstreetmap.org/export/embed.html?bbox=82.9972521%2C25.2810739%2C83.0072521%2C25.2910739&layer=mapnik&marker=25.2860739%2C83.0022521';

export const clinic = {
  name: 'My Dentist',
  listingName: 'My Dentist Dental clinic',
  tagline: `Clear, careful dental care for families in ${configuredCity}.`,
  description:
    `Visit My Dentist in ${configuredCity} for dental check-ups, root canal treatment, implants, emergency care, smile design and kids dentistry. Book today.`,
  siteUrl: env('VITE_SITE_URL', 'https://www.example.com').replace(/\/$/, ''),
  logo: '/images/my-dentist-logo.png',
  phone: configuredPhone,
  phoneDisplay: configuredPhone || 'Call clinic',
  phoneHref: configuredPhone ? `tel:${configuredPhone.replace(/[^\d+]/g, '')}` : '#booking',
  whatsapp: configuredWhatsapp,
  whatsappHref: configuredWhatsappHref,
  email: configuredEmail,
  emailDisplay: configuredEmail,
  emailHref: configuredEmail ? `mailto:${configuredEmail}` : '#booking',
  streetAddress: configuredAddress,
  postalCode: configuredPostcode,
  addressLines: [configuredAddress].filter(Boolean),
  openingHours: ['Monday, Tuesday, Thursday - Sunday: 10:00 AM - 8:00 PM', 'Wednesday: Closed'],
  locality: configuredCity,
  region: configuredRegion,
  country: configuredCountry,
  mapUrl: configuredMapUrl,
  mapEmbedUrl: env('VITE_MAP_EMBED_URL', defaultMapEmbedUrl),
  gmbUrl: configuredGmbUrl,
  socialLinks: [
    { label: 'Facebook', href: env('VITE_FACEBOOK_URL', 'https://www.facebook.com/mydentistvaranasi') },
    { label: 'Instagram', href: env('VITE_INSTAGRAM_URL', 'https://www.instagram.com/mydentistvaranasi') },
    { label: 'YouTube', href: env('VITE_YOUTUBE_URL') },
    { label: 'WhatsApp', href: configuredWhatsappHref }
  ],
  geo: {
    latitude: 25.2860739,
    longitude: 83.0022521
  },
  areaServed: configuredCity,
  serviceAreas: ['Varanasi', 'Lanka', 'Bhelupur', 'Sigra', 'Mahmoorganj', 'Assi'],
  sameAs: [
    configuredGmbUrl,
    configuredMapUrl,
    env('VITE_FACEBOOK_URL', 'https://www.facebook.com/mydentistvaranasi'),
    env('VITE_INSTAGRAM_URL', 'https://www.instagram.com/mydentistvaranasi'),
    env('VITE_YOUTUBE_URL')
  ].filter(Boolean),
  priceRange: '$$'
};

export const navItems = [
  { label: 'Treatments', href: '/#treatments' },
  { label: 'The Dentist', href: '/#dentist' },
  { label: 'New Patients', href: '/#booking' },
  { label: 'Gallery', href: '/gallery/' },
  { label: 'Blog', href: '/blog/' },
  { label: 'Contact', href: '/#location' }
];

export const doctors = [
  {
    slug: 'dr-mayank-shah',
    name: 'Dr. Mayank Shah',
    role: 'Specialist Prosthodontist & Implantologist',
    initials: 'MS',
    image: '/images/doctor-mayank-cutout-current.png',
    imageAlt: 'Dr. Mayank Shah at My Dentist dental clinic in Varanasi',
    profileImage: '/images/doctor-mayank-cutout-current.png',
    profileImageAlt: 'Dr. Mayank Shah prosthodontist and implantologist at My Dentist in Varanasi',
    heroImage: '/images/doctor-mayank-cutout-current.png',
    heroCutout: '/images/doctor-mayank-cutout-current.png',
    heroImageAlt: 'Dr. Mayank Shah prosthodontist and implantologist at My Dentist in Varanasi',
    summary:
      'Focused on replacing missing teeth, rebuilding damaged teeth and explaining treatment choices clearly before work begins.',
    bio:
      'Dr. Mayank Shah focuses on prosthodontic, implant and restorative dentistry, including missing teeth, damaged teeth, crowns, bridges, dentures, full-mouth rehabilitation and root canal treatment planning. His consultations are designed to help patients understand the condition, available options, expected maintenance and realistic treatment sequence before they decide.',
    focus: ['Dental Implants', 'Full-Mouth Rehabilitation', 'Crowns & Bridges (Caps)', 'Root Canal Treatment'],
    qualification: 'B.D.S., M.D.S. (LKO), FAGE, FISOI',
    experience: '17+ Years of Experience',
    registrationNumber: '6181',
    credentials: [
      'Specialist Prosthodontist & Implantologist',
      'Professor, Awadh Dental College, Jamshedpur',
      'Ex. Consultant, Govt. Medical College, Allahabad',
      'Ex. Asst. Professor, IDS, Bareilly'
    ],
    careApproach: [
      'Explains replacement options for missing teeth in clear, practical language.',
      'Plans crowns, bridges and implant-supported solutions according to oral health and suitability.',
      'Helps patients compare benefits, limitations, timing and maintenance before treatment.'
    ],
    helpfulFor: ['Missing teeth', 'Broken or heavily filled teeth', 'Full-mouth rehabilitation planning', 'Root canal and crown decisions']
  },
  {
    slug: 'dr-deepti-shah',
    name: 'Dr. Deepti Shah',
    role: 'Specialist Pedodontist',
    initials: 'DS',
    image: '/images/doctor-deepti-cutout-current.png',
    imageAlt: 'Dr. Deepti Shah at My Dentist dental clinic in Varanasi',
    profileImage: '/images/doctor-deepti-cutout-current.png',
    profileImageAlt: 'Dr. Deepti Shah pediatric dentist at My Dentist in Varanasi',
    heroImage: '/images/doctor-deepti-cutout-current.png',
    heroCutout: '/images/doctor-deepti-cutout-current.png',
    heroImageAlt: 'Dr. Deepti Shah pediatric dentist at My Dentist in Varanasi',
    summary:
      'Provides careful pediatric, preventive, restorative and family-focused dental care with a calm appointment experience.',
    bio:
      'Dr. Deepti Shah focuses on pediatric dentistry and family dental care, especially helping children and parents understand check-ups, preventive care, fillings, oral hygiene guidance and age-appropriate treatment needs. Her approach is calm, explanatory and practical, so families know what is being checked and why it matters.',
    focus: ['Child Dental Care', 'Preventive Dentistry', 'Tooth-Coloured Fillings', 'Family Dentistry'],
    qualification: 'B.D.S., D.Pedodont (LKO), FAGE',
    experience: '17+ Years of Experience',
    registrationNumber: '5693',
    credentials: [
      'Specialist Pedodontist',
      'Ex. Lecturer, IDS, Bareilly',
      'Ex. Consultant, Oral Maxillofacial Center, LKO',
      "Ex. Consultant, Dr. Verma's Clinic, Agra"
    ],
    careApproach: [
      'Supports children and parents with clear, age-appropriate dental guidance.',
      'Focuses on prevention, early diagnosis and practical home-care advice.',
      'Helps families understand treatment options without pressure or confusion.'
    ],
    helpfulFor: ['Child dental check-ups', 'Kids fillings', 'Preventive care', 'Family dental guidance']
  }
];

export const bookingReasons = [
  { value: 'implants', label: 'Dental Implants' },
  { value: 'full-mouth-rehabilitation', label: 'Full-Mouth Rehabilitation' },
  { value: 'aesthetic-dentistry', label: 'Aesthetic Dentistry / Smile Makeover' },
  { value: 'root-canal', label: 'Root Canal Treatment' },
  { value: 'aligners-braces', label: 'Aligners / Dental Braces' },
  { value: 'crowns-bridges', label: 'Crowns & Bridges (Caps)' },
  { value: 'filling', label: 'Tooth Filling' },
  { value: 'extraction', label: 'Tooth Extraction' },
  { value: 'checkup-cleaning', label: 'Dental check-up or teeth cleaning' },
  { value: 'emergency', label: 'Tooth pain or dental emergency' },
  { value: 'children', label: 'Child dental appointment' },
  { value: 'not-sure', label: 'I am not sure yet' }
];

export const timeSlots = [
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30'
];

const commonProcess = [
  { title: 'Listen first', text: 'We begin with your symptoms, priorities, medical history and any previous dental experiences that affect care.' },
  { title: 'Assess carefully', text: 'The dentist checks the relevant teeth, gums, bite and supporting tissues before recommending treatment.' },
  { title: 'Explain options', text: 'You receive a plain-English explanation of benefits, risks, alternatives, timing and likely maintenance.' },
  { title: 'Plan the next step', text: 'If treatment is suitable, the visit ends with a clear plan and realistic expectations before you decide.' }
];

export const treatments = [
  {
    slug: 'preventive',
    category: 'Check-up & cleaning',
    title: 'Dental check-up and teeth cleaning',
    shortTitle: 'Check-up',
    image: '/images/service-preventive-original.jpg',
    imageAlt: 'Dental check-up and teeth cleaning instruments with a clean teeth model',
    hero: 'Keep small problems small.',
    metaTitle: 'Dental Check-up and Teeth Cleaning in Varanasi | My Dentist',
    metaDescription:
      'Book dental check-ups, teeth cleaning, scaling, polishing, gum care, fluoride treatment and sealants at My Dentist in Varanasi.',
    summary:
      'Routine dental check-ups and teeth cleaning help spot decay, gum problems and mouth changes early, before they become painful or complex.',
    popularServices: ['Dental check-up', 'Teeth cleaning / scaling', 'Gum care', 'Fluoride & sealants'],
    proof: [
      ['Early checks', 'Small changes are easier to explain and manage when they are found early.'],
      ['Cleaner teeth', 'Scaling and polishing remove plaque and deposits that brushing cannot always clear.'],
      ['Simple advice', 'Home-care guidance is focused on the areas you actually find difficult.']
    ],
    points: [
      ['Detect early', 'Examinations look for small changes before they become painful or harder to manage.'],
      ['Control risk', 'Diet, plaque, dry mouth, smoking and medical history can all affect prevention planning.'],
      ['Maintain results', 'Hygiene support protects previous fillings, crowns, implants and orthodontic work.']
    ],
    services: [
      ['Dental check-up', 'A routine examination checks teeth, gums, bite and mouth tissues. X-rays are advised only when they help confirm what is happening.'],
      ['Teeth cleaning / scaling and polishing', 'Professional cleaning removes plaque, tartar and stains, then pairs it with practical brushing and flossing guidance.'],
      ['Gum care for bleeding gums', 'Gum measurements and risk factors help identify simple inflammation or deeper gum problems that need planned care.'],
      ['Fluoride treatment', 'Fluoride varnish or stronger home-care advice may be recommended for sensitive teeth, dry mouth, exposed roots or higher decay risk.'],
      ['Fissure sealants', 'A protective coating can be placed on suitable back teeth to make deep grooves easier to keep clean.'],
      ['Mouth and oral cancer check', 'Routine visits include a check for ulcers, patches, lumps and tissue changes that may need monitoring or referral.']
    ],
    whoBenefits: ['You want a routine dental check-up.', 'Your gums bleed when brushing or flossing.', 'You need teeth cleaning or scaling.', 'Your mouth feels dry or your decay risk has changed.'],
    process: commonProcess,
    faqs: [
      ['How often should I have a dental check-up?', 'The interval depends on your current oral health and risk of future disease. The dentist should explain the recommended timing after assessment.'],
      ['Is a dental examination the same as a hygiene appointment?', 'No. An examination diagnoses and plans care; hygiene appointments focus on cleaning, gum health and home-care support.'],
      ['Are X-rays needed at every visit?', 'No. Radiographs are taken only when the expected diagnostic benefit justifies them.'],
      ['Does teeth cleaning damage enamel?', 'Professional cleaning does not remove healthy enamel when performed appropriately. It removes deposits and supports gum health.']
    ],
    related: ['children', 'restorative', 'emergency']
  },
  {
    slug: 'restorative',
    category: 'Tooth repair',
    title: 'Root canal treatment, fillings, crowns & bridges',
    shortTitle: 'Root Canal',
    image: '/images/service-root-canal-original.jpg',
    imageAlt: 'Root canal tooth model with endodontic files prepared for tooth-saving care',
    hero: 'Repair what is damaged. Preserve what is healthy.',
    metaTitle: 'Root Canal Treatment, Fillings and Crowns in Varanasi',
    metaDescription:
      'Visit My Dentist in Varanasi for tooth fillings, root canal treatment, dental crowns, bridges and broken tooth repair after diagnosis.',
    summary:
      'Tooth repair care covers root canal treatment, tooth fillings, crowns and bridges, caps, broken teeth and tooth extraction planning, with the aim of saving healthy tooth wherever possible.',
    popularServices: ['Root Canal Treatment', 'Tooth Filling', 'Crowns & Bridges (Caps)', 'Tooth Extraction'],
    proof: [
      ['Tooth preservation', 'Treatment choices are planned around remaining healthy structure.'],
      ['Clear diagnosis', 'We explain why a filling, root canal, crown, bridge or extraction may be suitable.'],
      ['Long-term thinking', 'Repairs are planned with bite forces, maintenance and future risk in mind.']
    ],
    points: [
      ['Restore comfort', 'Repair can reduce sensitivity, rough edges and food trapping.'],
      ['Rebuild function', 'The right restoration helps teeth withstand everyday chewing forces.'],
      ['Plan maintenance', 'A successful repair includes cleaning advice and review timing.']
    ],
    services: [
      ['Root Canal Treatment', 'Root canal treatment is considered when infection or deep decay reaches the nerve space and the tooth may still be saved.'],
      ['Tooth Filling', 'Tooth-coloured fillings repair small to moderate decay, chips or worn areas with careful shaping and bonding.'],
      ['Crowns & Bridges (Caps)', 'Crowns cover and protect weakened teeth, while bridges can replace one or more missing teeth by using nearby teeth or implants for support.'],
      ['Tooth Extraction', 'If a tooth cannot be predictably saved, extraction options and replacement choices are explained before treatment.'],
      ['Broken or chipped tooth repair', 'Sharp, chipped or fractured teeth may be smoothed, bonded, filled or protected depending on the damage.'],
      ['Old filling or cap replacement', 'Loose, leaking or uncomfortable restorations are assessed before deciding whether repair, replacement or a different treatment is safer.']
    ],
    whoBenefits: ['A filling, crown or old restoration has broken.', 'You may need root canal treatment or RCT.', 'A tooth has heavy wear, cracks or repeated repairs.', 'You want to understand repair or extraction options before committing.'],
    process: commonProcess,
    faqs: [
      ['Do I need a crown or a filling?', 'That depends on the amount of healthy tooth remaining, crack risk, bite forces and how much protection the tooth needs.'],
      ['Is root canal treatment always needed for tooth pain?', 'No. Tooth pain can come from decay, gum problems, cracks, bite trauma or sensitivity. Diagnosis is needed before deciding.'],
      ['Will a restored tooth last forever?', 'No dental restoration lasts forever. Longevity depends on design, oral hygiene, bite forces and review care.'],
      ['Can broken teeth always be saved?', 'Not always. The dentist will explain whether repair, root treatment, crown protection or extraction is the safer option.']
    ],
    related: ['preventive', 'implants', 'emergency']
  },
  {
    slug: 'cosmetic',
    category: 'Smile improvement',
    title: 'Aesthetic dentistry, aligners and smile design',
    shortTitle: 'Aesthetic',
    image: '/images/service-aesthetic-dentistry-original.jpg',
    imageAlt: 'Dental shade guide and clear aligner tray used for aesthetic dentistry planning',
    hero: 'A smile plan built around you.',
    metaTitle: 'Teeth Whitening and Smile Design in Varanasi | My Dentist',
    metaDescription:
      'Plan teeth whitening, smile design, composite bonding, veneers, braces and clear aligners at My Dentist in Varanasi after assessment.',
    summary:
      'Aesthetic dentistry can include smile makeover planning, teeth whitening, bonding, veneers, dental braces or clear aligners, planned around tooth health and a natural-looking result.',
    popularServices: ['Aesthetic Dentistry', 'Smile Makeover', 'Aligners', 'Teeth Whitening'],
    proof: [
      ['Conservative first', 'We consider lower-intervention options before irreversible treatment.'],
      ['Natural planning', 'Shade, shape, gum line and facial proportions are considered together.'],
      ['Oral health first', 'Gum health, decay and bite concerns are addressed before cosmetic work.']
    ],
    points: [
      ['Clarify goals', 'A consultation separates what you dislike from what is clinically sensible to change.'],
      ['Compare options', 'Whitening, bonding, veneers and aligners solve different problems.'],
      ['Protect teeth', 'A good result should be attractive and maintainable, not just quick.']
    ],
    services: [
      ['Aesthetic Dentistry', 'A consultation reviews tooth colour, alignment, shape, gums and bite before choosing the most conservative smile-improvement route.'],
      ['Smile Makeover', 'Smile makeover planning combines photos, shade discussion and treatment sequencing so changes are realistic and maintainable.'],
      ['Teeth Whitening', 'Dentist-supervised whitening uses assessed trays and gels to brighten natural teeth safely and predictably.'],
      ['Composite Bonding', 'Bonding can reshape edges, close small gaps or repair chips with minimal tooth preparation in suitable cases.'],
      ['Dental veneers', 'Veneers can alter colour, shape and proportions when more significant change is needed and the case is suitable.'],
      ['Dental Braces and Aligners', 'If tooth position is the main issue, braces or clear aligners may be more appropriate before whitening, bonding or veneers.']
    ],
    whoBenefits: ['You want whiter teeth but are unsure what is safe.', 'You have chipped edges, small gaps or uneven tooth shape.', 'You are comparing bonding, veneers, braces and aligners.', 'You want a natural result rather than an over-treated look.'],
    process: commonProcess,
    faqs: [
      ['Is whitening safe?', 'Dentist-supervised whitening is generally safe for suitable patients, but gums, decay, sensitivity and restorations must be assessed first.'],
      ['Is bonding reversible?', 'Bonding can be conservative, but it still needs maintenance and can stain or chip over time.'],
      ['Do veneers damage teeth?', 'Some veneer cases require enamel preparation. The dentist should explain preparation, alternatives and long-term maintenance before treatment.'],
      ['Should I whiten before bonding or veneers?', 'Often yes, because whitening changes natural tooth colour. The dentist can advise the right order after assessment.']
    ],
    related: ['preventive', 'restorative', 'children']
  },
  {
    slug: 'implants',
    category: 'Missing teeth',
    title: 'Dental implants and missing teeth',
    shortTitle: 'Implants',
    image: '/images/service-dental-implants-original.jpg',
    imageAlt: 'Dental implant, abutment and crown model for missing tooth replacement planning',
    hero: 'Replace missing teeth with a plan built for the long term.',
    metaTitle: 'Dental Implants and Missing Tooth Replacement in Varanasi',
    metaDescription:
      'Discuss dental implants, implant bridges, dentures and missing tooth replacement options at My Dentist in Varanasi after clinical assessment.',
    summary:
      'Missing teeth can often be replaced with dental implants, bridges or dentures after checking bone, gums, bite and long-term maintenance needs.',
    popularServices: ['Dental Implants', 'Full-Mouth Rehabilitation', 'Implant bridge', 'Dentures / implant dentures'],
    proof: [
      ['Assessment-led', 'Suitability is checked before treatment is recommended.'],
      ['Replacement choices', 'Implants are compared with bridges, dentures and doing nothing.'],
      ['Maintenance matters', 'Implants still need healthy gums and long-term review.']
    ],
    points: [
      ['Understand suitability', 'Medical history, gum health and bone volume affect implant planning.'],
      ['Plan the final tooth', 'The visible crown or bridge guides where the implant should be placed.'],
      ['Protect investment', 'Maintenance advice reduces the risk of inflammation around implants.']
    ],
    services: [
      ['Dental Implants', 'A single implant can support a crown without preparing neighbouring teeth when the case is suitable.'],
      ['Full-Mouth Rehabilitation', 'Patients with multiple missing, worn or failing teeth can discuss staged full-mouth rehabilitation planning after detailed assessment.'],
      ['Multiple teeth implant bridge', 'Several missing teeth may be replaced with a bridge supported by implants rather than a removable denture.'],
      ['Full-mouth implant options', 'Patients missing many teeth can discuss fixed or removable full-arch options after detailed planning.'],
      ['Dentures and implant-supported dentures', 'Dentures or implant-supported dentures may help when several teeth are missing or a fixed option is not suitable.'],
      ['Bone and gum assessment', 'Scans and clinical checks help identify whether additional procedures may be needed before placement.'],
      ['Implant maintenance', 'Cleaning access, gum monitoring and review appointments are part of responsible implant care.']
    ],
    whoBenefits: ['You are missing one tooth and want a fixed replacement.', 'A denture feels loose or difficult to tolerate.', 'You are comparing an implant with a bridge.', 'You want to know whether you have enough bone for treatment.'],
    process: commonProcess,
    faqs: [
      ['Is everyone suitable for implants?', 'No. Suitability depends on health, smoking, gum disease, bone volume, medication and ability to maintain the implant.'],
      ['How long does implant treatment take?', 'Timing varies by case. Assessment, healing, placement and final restoration can take several months.'],
      ['Is an implant better than a bridge?', 'Not always. An implant avoids preparing adjacent teeth but involves surgery. A bridge may fit better in some cases.'],
      ['Do implants need cleaning?', 'Yes. Implants need daily cleaning and professional maintenance because the surrounding gum and bone can still become inflamed.']
    ],
    related: ['restorative', 'preventive', 'cosmetic']
  },
  {
    slug: 'emergency',
    category: 'Urgent care',
    title: 'Tooth pain and emergency dentist',
    shortTitle: 'Emergency',
    image: '/images/service-emergency-original.jpg',
    imageAlt: 'Prepared dental treatment room and emergency tray for urgent tooth pain care',
    hero: 'Dental pain should not wait for a generic form.',
    metaTitle: 'Emergency Dentist and Tooth Pain Relief in Varanasi',
    metaDescription:
      'Request urgent dental advice in Varanasi for tooth pain, swelling, broken teeth, lost fillings, wisdom tooth pain or dental trauma.',
    summary:
      'Urgent dental care focuses on tooth pain relief, swelling, broken teeth, lost fillings, wisdom tooth pain and clear follow-up planning.',
    popularServices: ['Toothache relief', 'Broken tooth repair', 'Lost filling or crown', 'Wisdom tooth pain'],
    proof: [
      ['Prompt triage', 'Symptoms are prioritised so urgent problems are not missed.'],
      ['Pain relief first', 'The first goal is to reduce pain and stabilise the situation.'],
      ['Clear follow-up', 'You leave knowing what has been done and what happens next.']
    ],
    points: [
      ['Assess risk', 'Swelling, fever, trauma and uncontrolled bleeding need urgent attention.'],
      ['Stabilise damage', 'Broken teeth, lost fillings and crowns can often be temporarily or permanently repaired.'],
      ['Plan safely', 'Complex emergencies may need staged treatment after the urgent visit.']
    ],
    services: [
      ['Severe toothache / tooth pain', 'The dentist identifies likely causes such as decay, infection, cracks, gum problems or bite trauma.'],
      ['Swelling or dental abscess', 'Swelling is assessed promptly and managed with treatment planning, drainage or referral where required.'],
      ['Broken or chipped tooth', 'Sharp or fractured teeth may be smoothed, bonded, restored or protected depending on the damage.'],
      ['Lost fillings or crowns', 'A lost restoration can expose sensitive tooth structure and should be assessed before the tooth deteriorates further.'],
      ['Knocked-out or loose tooth', 'Dental trauma is time-sensitive. Call immediately for advice on storage, handling and urgent care.'],
      ['Wisdom tooth pain / urgent extraction', 'Pain around wisdom teeth may involve gum inflammation, infection or bite trauma that needs assessment.']
    ],
    whoBenefits: ['You have severe or worsening tooth pain.', 'Your face or gum is swollen.', 'A tooth, filling or crown has broken.', 'You have had dental trauma or bleeding that concerns you.'],
    process: commonProcess,
    faqs: [
      ['What counts as a dental emergency?', 'Severe pain, swelling, trauma, uncontrolled bleeding, a knocked-out tooth or signs of spreading infection need urgent advice.'],
      ['Should I go to hospital?', 'Go to urgent medical care if swelling affects breathing, swallowing or the eye area, or if you feel seriously unwell.'],
      ['Can the problem be fixed on the same day?', 'Sometimes. The urgent visit may provide definitive care or stabilise the tooth before planned follow-up treatment.'],
      ['Can painkillers solve tooth pain?', 'Painkillers may reduce symptoms temporarily, but they do not diagnose or treat the cause.']
    ],
    related: ['restorative', 'preventive', 'children']
  },
  {
    slug: 'children',
    category: 'Children',
    title: 'Kids dentist and child dental care',
    shortTitle: 'Kids',
    image: '/images/service-child-dentistry-original.jpg',
    imageAlt: 'Child-friendly dental room with toothbrush, tooth model and preventive care items',
    hero: 'Dental visits that build confidence.',
    metaTitle: 'Kids Dentist and Child Dental Care in Varanasi',
    metaDescription:
      'Book children\'s dental check-ups, fluoride treatment, fissure sealants, kids fillings and child tooth pain advice at My Dentist in Varanasi.',
    summary:
      'Kids dental visits should feel calm and easy to understand, helping children build trust while parents get practical prevention advice.',
    popularServices: ['Child dental check-up', 'Kids fillings', 'Fluoride & sealants', 'Child tooth pain'],
    proof: [
      ['Calm introduction', 'Early visits focus on familiarity and confidence.'],
      ['Parent guidance', 'Advice covers brushing, diet, fluoride and habits at home.'],
      ['Prevention first', 'Small preventive steps can reduce future treatment needs.']
    ],
    points: [
      ['Build trust', 'A gentle first visit can make future dental care easier.'],
      ['Spot risk early', 'Growth, tooth eruption, decay risk and habits are reviewed over time.'],
      ['Support parents', 'Advice is practical, realistic and specific to the child.']
    ],
    services: [
      ['Child dental check-up', 'A calm review of teeth, gums, bite development and brushing habits, adapted to the child\'s age.'],
      ['Fluoride treatment for children', 'Fluoride varnish can support enamel strength where recommended after risk assessment.'],
      ['Fissure sealants for kids', 'Selected permanent molars may be sealed to protect deep grooves from plaque and food trapping.'],
      ['Brushing and diet advice for parents', 'Parents receive practical guidance on snacks, drinks, toothpaste amount and tricky cleaning areas.'],
      ['Kids fillings', 'When treatment is needed, options are explained clearly and kept as calm and child-friendly as possible.'],
      ['Toothache or broken tooth in children', 'Pain, trauma, swelling or broken teeth are assessed with reassurance and clear next steps.']
    ],
    whoBenefits: ['Your child is ready for a first dental visit.', 'You want help with brushing, diet or fluoride advice.', 'A child has tooth pain, trauma or a broken tooth.', 'You want a kids dentist visit to feel calm rather than frightening.'],
    process: commonProcess,
    faqs: [
      ['When should a child first see a dentist?', 'Children should usually visit when their first teeth appear or by around their first birthday, then follow dentist advice.'],
      ['How can I prepare an anxious child?', 'Keep the explanation simple, positive and honest. Tell the clinic team about anxiety before the visit so the appointment can be adapted.'],
      ['Are baby teeth important?', 'Yes. Baby teeth help eating, speech, spacing and comfort, and decay can affect a child\'s wellbeing.'],
      ['What if my child has tooth pain?', 'Call or WhatsApp the clinic for advice. Pain, swelling or trauma should be assessed promptly.']
    ],
    related: ['preventive', 'emergency', 'cosmetic']
  }
];

export const featuredTreatments = [
  {
    title: 'Dental Implants',
    eyebrow: 'Missing teeth',
    href: '/treatments/implants/',
    image: '/images/service-dental-implants-original.jpg',
    imageAlt: 'Dental implant, abutment and crown model for missing tooth replacement planning',
    summary: 'For replacing missing teeth after checking bone, gums, bite and long-term maintenance needs.',
    iconType: 'implant'
  },
  {
    title: 'Full-Mouth Rehab',
    eyebrow: 'Advanced planning',
    href: '/treatments/implants/#services',
    image: '/images/service-full-mouth-rehab-original.jpg',
    imageAlt: 'Full-mouth rehabilitation planning models, implant parts and diagnostic records',
    summary: 'For multiple missing, worn or failing teeth where treatment needs to be planned in stages.',
    iconType: 'implant'
  },
  {
    title: 'Aesthetic Dentistry',
    eyebrow: 'Smile improvement',
    href: '/treatments/cosmetic/',
    image: '/images/service-aesthetic-dentistry-original.jpg',
    imageAlt: 'Dental shade guide and clear aligner tray used for smile planning',
    summary: 'For smile makeover, teeth whitening, bonding, veneers, braces or aligners after oral health assessment.',
    iconType: 'sparkle'
  },
  {
    title: 'Root Canal',
    eyebrow: 'Tooth saving care',
    href: '/treatments/restorative/',
    image: '/images/service-root-canal-original.jpg',
    imageAlt: 'Root canal tooth model with endodontic files prepared for tooth-saving care',
    summary: 'For infected or deeply decayed teeth where saving the natural tooth may still be possible.',
    iconType: 'tooth'
  },
  {
    title: 'Aligners',
    eyebrow: 'Teeth alignment',
    href: '/treatments/cosmetic/#services',
    image: '/images/service-aligners-original.jpg',
    imageAlt: 'Clear aligners and braces model for teeth alignment planning',
    summary: 'For mild to moderate alignment concerns after checking bite, gums and treatment suitability.',
    iconType: 'braces'
  },
  {
    title: 'Child Dentistry',
    eyebrow: 'Kids care',
    href: '/treatments/children/',
    image: '/images/service-child-dentistry-original.jpg',
    imageAlt: 'Child-friendly dental room with toothbrush and tooth model for kids dental care',
    summary: 'For children needing check-ups, fillings, prevention or a calm first dental visit.',
    iconType: 'tooth'
  }
];

export const reviews = [
  {
    author: 'Prakhar Bhatt',
    details: '3 reviews',
    timeAgo: '3 weeks ago',
    isNew: true,
    rating: 5,
    quote:
      'The doctor explained everything clearly and provided painless treatment. The clinic is clean, well-maintained, and appointments are handled efficiently. Highly recommended for quality dental care.'
  },
  {
    author: 'Vibha Singh',
    details: '5 reviews - 2 photos',
    timeAgo: '4 months ago',
    rating: 5,
    quote:
      'Dr Mayank shah made the whole experience of RCT comfortable and pain free ,and is very precise with the procedure!!'
  },
  {
    author: 'Ayush Pandey',
    details: '13 reviews',
    timeAgo: 'a year ago',
    rating: 5,
    quote:
      'I had a fantastic experience at Dr Mayank Shah dental clinic. From the moment I walked in, the staff was welcoming, professional, and attentive. The office was clean, modern, and comfortable, which helped put me at ease right away.\n\nDr. Mayank Shah was thorough, gentle, and took the time to explain everything clearly. I really appreciated the care and attention to detail throughout the entire visit. It\'s clear they genuinely care about their patients\' comfort and long-term dental health.\n\nHighly recommend to anyone looking for a trustworthy and skilled dental team!'
  },
  {
    author: 'Abhi Thakur',
    details: 'Local Guide',
    timeAgo: 'July 16, 2026',
    rating: 5,
    quote:
      'My father had been struggling with missing teeth for many years, which made eating difficult. The team explained the replacement options clearly and handled the visit with patience.'
  },
  {
    author: 'Asys Zjjz',
    details: 'Google review',
    timeAgo: 'July 16, 2026',
    rating: 5,
    quote:
      'I had multiple damaged teeth that required root canal treatment, and I was worried before the appointment. The treatment was explained well and the experience felt comfortable.'
  },
  {
    author: 'Prashant Lodhi',
    details: 'Google review',
    timeAgo: 'July 16, 2026',
    rating: 5,
    quote: 'Excellent experience.'
  },
  {
    author: 'Mohd Arslan',
    details: 'Google review',
    timeAgo: 'July 16, 2026',
    rating: 5,
    quote:
      'After postponing treatment for several years, I finally decided to replace my missing tooth. The consultation was clear and the clinic team made the process easier.'
  },
  {
    author: 'Bablu Soni',
    details: 'Google review',
    timeAgo: 'July 16, 2026',
    rating: 5,
    quote:
      'An old missing tooth had started affecting my confidence while smiling, so I finally decided to get advice. The doctor explained the options in a simple way.'
  },
  {
    author: 'Guddu Kaushal',
    details: 'Google review',
    timeAgo: 'July 16, 2026',
    rating: 5,
    quote:
      'For years, I wanted to correct my misaligned teeth but kept postponing treatment. The appointment helped me understand what could be done and what to expect.'
  }
];

const clinicGalleryImages = [
  {
    src: '/images/clinic-exterior-real.png',
    alt: 'My Dentist clinic exterior and entrance in Varanasi',
    title: 'Clinic exterior'
  },
  {
    src: '/images/clinic-reception-real.png',
    alt: 'My Dentist clinic reception and waiting area',
    title: 'Reception and waiting area'
  },
  {
    src: '/images/clinic-treatment-room-real.png',
    alt: 'My Dentist dental treatment room',
    title: 'Treatment room'
  }
];

const caseGalleryImages = Array.from({ length: 12 }, (_, index) => {
  const number = String(index + 1).padStart(2, '0');
  return {
    src: `/gallery/clinic-gallery-${number}.jpeg`,
    alt: `My Dentist dental case gallery photo ${index + 1}`,
    title: `Case gallery ${index + 1}`
  };
});

export const galleryImages = [...clinicGalleryImages, ...caseGalleryImages];

const articleSections = {
  examinations: [
    ['What a dental examination checks', 'A useful dental examination is more than a quick look for cavities. The dentist reviews tooth surfaces, gum health, soft tissues, bite, old fillings, crowns, implants, sensitivity, wear and anything you have noticed since your last visit. X-rays are considered only when they are likely to add useful diagnostic information.'],
    ['Why early detection matters', 'Small areas of decay, gum inflammation and cracks are often easier to manage when they are found early. Early care can mean simpler treatment, clearer choices and less uncertainty about whether a tooth can be restored.'],
    ['How recall timing is decided', 'Recall intervals should be based on risk. A patient with stable gum health and low decay risk may not need the same frequency as someone with recent disease, dry mouth, heavy wear or complex restorations.'],
    ['Questions to ask at your check-up', 'Ask whether your gums are healthy, whether any fillings are weakening, whether X-rays are needed now or later, which areas are being missed while brushing and when your next review should be. A good check-up should leave you with practical next steps, not confusion.']
  ],
  whitening: [
    ['Why assessment comes first', 'Sensitivity, gum problems, decay, cracks and leaking restorations can change what is safe or realistic. Whitening should not be started on an untreated dental problem.'],
    ['Professional whitening and safety', 'Professional whitening starts with an assessment because sensitivity, gum problems, decay and existing restorations can change what is safe or realistic. Whitening gels work on natural tooth structure, not crowns, veneers, bonding or fillings.'],
    ['What results to expect', 'Shade change varies between patients. The aim is a cleaner, brighter smile that still suits your tooth type and complexion, not an artificial target shade.'],
    ['Managing sensitivity', 'Sensitivity is usually temporary but should be planned for. Your dentist may adjust the whitening schedule, gel strength or toothpaste advice if you are prone to discomfort.'],
    ['Whitening before other cosmetic work', 'If you are considering bonding, veneers or crowns, whitening may need to happen first so new restorations can be matched to the final shade.']
  ],
  firstAppointment: [
    ['Before the examination', 'Your first appointment should begin with medical history, dental concerns, goals and any worries about treatment. This context helps the dentist understand what matters to you.'],
    ['During the assessment', 'The dentist checks teeth, gums, soft tissues, bite and restorations. Photographs or X-rays may be recommended when they help explain findings.'],
    ['After the visit', 'You should leave with a clear explanation of urgent needs, optional improvements, costs and timing. A written plan helps you compare choices without pressure.'],
    ['What to bring', 'Bring medical and medication details, previous dental records if available, a list of symptoms or questions, and information about allergies or health conditions.'],
    ['If you are nervous', 'Ask for pauses, step-by-step explanations and a clear signal if you need a break. Good dental care should not feel rushed.']
  ],
  fillingOnlayOrCrown: [
    ['Why size matters', 'When more tooth structure is missing, the remaining tooth may flex or fracture under chewing pressure. Larger restorations are planned to protect what is left.'],
    ['Fillings', 'Fillings are usually suitable for smaller defects where enough healthy tooth remains to support the repair.'],
    ['Onlays', 'An onlay covers one or more weakened cusps while preserving more tooth than a full crown in suitable cases.'],
    ['Crowns', 'A crown covers the tooth more fully and may be recommended after root canal treatment, heavy cracks, large fillings or significant wear.'],
    ['Cracks and bite forces', 'Pain on biting can suggest crack movement. The dentist checks whether cusps need coverage to reduce future fracture risk.']
  ],
  implantConsultation: [
    ['Suitability checks', 'The dentist reviews medical history, medication, smoking, gum health and the condition of nearby teeth. These factors affect risk and timing.'],
    ['Records and planning', 'Photographs, X-rays or scans may be needed to assess bone, spacing and the final crown position.'],
    ['Comparing alternatives', 'Implants should be compared with bridges, dentures or no replacement. Each choice has different benefits, risks, timing and maintenance.'],
    ['Maintenance planning', 'Implants need daily cleaning and professional review. Gum inflammation around implants can affect long-term stability.'],
    ['Questions to ask', 'Ask whether you are suitable for an implant, whether you have enough bone, what the alternatives are, how long treatment may take and how the implant should be cleaned.']
  ],
  childFirstVisit: [
    ['When to book', 'Children should usually see a dentist when teeth appear or by around their first birthday, then follow individual advice.'],
    ['How to prepare', 'Keep language simple and honest. Avoid promises that nothing will happen. Instead, explain that the dentist will count teeth and help keep them strong.'],
    ['What the dentist checks', 'The visit may include tooth eruption, brushing, diet, habits, fluoride advice and any areas that need monitoring.'],
    ['Parent guidance', 'Parents can ask about toothpaste amount, brushing help, snacks, drinks, thumb sucking, bottle habits and what to do if a tooth hurts.'],
    ['If your child is nervous', 'Tell the clinic before the appointment. A slower pace, gentle explanation and short first visit can help build trust.']
  ],
  bleedingGums: [
    ['Why gums bleed', 'Plaque is a common cause, but medication, smoking, pregnancy, medical conditions and established gum disease can influence bleeding.'],
    ['What a gum assessment measures', 'The dentist or hygienist may measure gum pocket depths, bleeding, recession, mobility and areas that collect plaque.'],
    ['What helps', 'Cleaning technique, interdental brushes and professional support are tailored to the findings rather than guessed.'],
    ['When to book', 'Book promptly if bleeding continues, gums are swollen, teeth feel loose, bad breath persists or you have diabetes, smoking history or previous gum disease.']
  ],
  bondingOrVeneers: [
    ['Preparation and reversibility', 'Bonding may need little or no drilling in suitable cases. Veneers can require enamel preparation depending on the desired change.'],
    ['Appearance and durability', 'Porcelain resists staining better, while composite is easier to repair. The best choice depends on bite, habits and expectations.'],
    ['Alignment first', 'If teeth are crowded or rotated, braces or aligners may be a better first step before bonding or veneers.'],
    ['Questions to ask', 'Ask how much tooth preparation is needed, whether whitening should happen first, what maintenance will be needed, what happens if an edge chips and whether alignment treatment is a better first step.']
  ],
  implantOrBridge: [
    ['When a bridge may fit', 'If neighbouring teeth already need crowns, a bridge may solve more than one problem at the same time.'],
    ['When an implant may fit', 'If adjacent teeth are healthy and implant risk is acceptable, an implant may preserve those teeth.'],
    ['Surgery and healing', 'Implants require surgical placement and healing time. Bridges usually avoid implant surgery but require preparation of supporting teeth.'],
    ['Cleaning and maintenance', 'Both options need careful cleaning. The dentist should show how each choice would be maintained.'],
    ['Decision checklist', 'Ask whether the neighbouring teeth are healthy, whether there is enough bone for an implant, how quickly the tooth needs replacement, how cleaning will work and what future maintenance to expect.']
  ],
  urgentCare: [
    ['Call quickly for swelling', 'Swelling, fever, difficulty swallowing or spreading infection symptoms need urgent advice because dental infections can escalate.'],
    ['Trauma is time-sensitive', 'A knocked-out adult tooth should be handled carefully and assessed immediately. Avoid scrubbing the root.'],
    ['Broken teeth and lost restorations', 'A broken tooth, lost filling or lost crown may expose sensitive tooth structure. It should be assessed before damage worsens.'],
    ['Pain relief is not diagnosis', 'Painkillers may help symptoms but do not identify the cause. A dentist needs to assess the tooth and surrounding tissues.'],
    ['When to seek medical emergency care', 'Seek urgent medical care if swelling affects breathing, swallowing or the eye area, or if you feel seriously unwell.']
  ],
  crackedTooth: [
    ['Why biting hurts', 'A crack can open slightly under pressure, then release. This movement can trigger sharp pain that is hard to reproduce.'],
    ['Why cracks are hard to see', 'Some cracks are hidden under old fillings, between teeth or below the gum line. Symptoms can come and go.'],
    ['How dentists investigate', 'The dentist may use bite tests, magnification, X-rays and restoration assessment to understand the likely crack pattern.'],
    ['Treatment choices', 'Some cracks are monitored, while others need bonding, an onlay, a crown or root canal treatment if the nerve is involved.'],
    ['When to book', 'Book an assessment if biting pain repeats, the tooth feels sensitive to cold, a filling has cracked, or pain lingers after chewing.']
  ],
  nervous: [
    ['Tell the team early', 'A note before the visit gives the dentist time to adapt the appointment and avoid rushing introductions.'],
    ['Agree control signals', 'A simple hand signal can help you pause treatment, ask a question or take a short break.'],
    ['Ask for plain explanations', 'Understanding what is happening next often reduces fear of the unknown. Ask for steps, timings and choices.'],
    ['Start with an assessment', 'If you have avoided dental care for a long time, start with an examination and conversation. You do not have to agree to treatment immediately.'],
    ['What to say when booking', 'Tell the clinic if you are nervous, have had a difficult past experience, prefer slower explanations or want a short first appointment.']
  ]
};

const blogImages = {
  preventive: {
    image: '/images/service-preventive-original.jpg',
    imageAlt: 'Dental check-up and teeth cleaning instruments with a clean teeth model'
  },
  cosmetic: {
    image: '/images/service-aesthetic-dentistry-original.jpg',
    imageAlt: 'Dental shade guide and clear aligner tray used for cosmetic smile planning'
  },
  firstVisit: {
    image: '/images/clinic-reception-real.png',
    imageAlt: 'My Dentist reception area for a first dental appointment in Varanasi'
  },
  restorative: {
    image: '/images/service-root-canal-original.jpg',
    imageAlt: 'Root canal tooth model with endodontic files used for tooth-saving dental care'
  },
  implants: {
    image: '/images/service-dental-implants-original.jpg',
    imageAlt: 'Dental implant, abutment and crown model for missing tooth replacement'
  },
  children: {
    image: '/images/service-child-dentistry-original.jpg',
    imageAlt: 'Child-friendly dental room with preventive dental care items'
  },
  emergency: {
    image: '/images/service-emergency-original.jpg',
    imageAlt: 'Prepared dental room and emergency tray for urgent dental care'
  }
};

export const blogPosts = [
  {
    slug: 'regular-dental-examinations',
    category: 'Preventive care',
    categorySlug: 'preventive',
    ...blogImages.preventive,
    title: 'Why regular dental examinations matter more than you think',
    metaTitle: 'Why Regular Dental Examinations Matter | My Dentist',
    metaDescription:
      'Learn what happens during a routine dental examination, why early detection matters and how dentists decide the right recall interval.',
    summary: 'What the dentist checks, why early changes are easier to manage and how an individual recall interval is decided.',
    readTime: '6 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'Regular dental examinations help identify decay, gum disease, oral tissue changes and bite problems before they become harder to treat.',
    takeaways: ['A check-up should include teeth, gums, soft tissues and risk review.', 'Recall timing should be individual, not automatic.', 'Early diagnosis can keep treatment simpler.'],
    sections: articleSections.examinations,
    faqs: [
      ['How often should I have a dental check-up?', 'The timing depends on your oral health risk. Your dentist should recommend an interval after examining your teeth and gums.'],
      ['Is teeth cleaning included in every check-up?', 'Not always. Cleaning is advised when deposits, stains or gum inflammation are present.'],
      ['Can a check-up find gum disease early?', 'Yes. Gum measurements and bleeding patterns can help identify inflammation or deeper gum problems.']
    ],
    relatedTreatment: 'preventive'
  },
  {
    slug: 'understanding-tooth-whitening',
    category: 'Cosmetic dentistry',
    categorySlug: 'cosmetic',
    ...blogImages.cosmetic,
    title: 'Understanding tooth whitening: what works and what to expect',
    metaTitle: 'Understanding Tooth Whitening | My Dentist',
    metaDescription:
      'Compare professional tooth whitening, home whitening, sensitivity and realistic shade changes before starting cosmetic dental care.',
    summary: 'Professional whitening, home kits, sensitivity and realistic shade changes.',
    readTime: '5 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'Tooth whitening works best when it is dentist-supervised, planned around sensitivity risk and matched to realistic expectations.',
    takeaways: ['Whitening affects natural teeth, not existing crowns or fillings.', 'A dental assessment should happen before whitening.', 'Sensitivity can usually be managed with the right plan.'],
    sections: articleSections.whitening,
    faqs: [
      ['Is whitening safe?', 'Dentist-supervised whitening is generally safe for suitable patients after assessment.'],
      ['Will whitening work on crowns or fillings?', 'No. Whitening affects natural tooth structure, not artificial restorative materials.'],
      ['How long do whitening results last?', 'It varies. Staining habits, diet, oral hygiene and maintenance affect how long the result stays bright.']
    ],
    relatedTreatment: 'cosmetic'
  },
  {
    slug: 'first-dental-appointment',
    category: 'Patient guidance',
    categorySlug: 'patient',
    ...blogImages.firstVisit,
    title: 'What to expect at your first appointment with us',
    metaTitle: 'First Dental Appointment: What to Expect | My Dentist',
    metaDescription:
      'A clear guide to your first dental appointment, from medical history and examination to treatment options and next steps.',
    summary: 'From arrival and assessment to understanding your written treatment plan.',
    readTime: '4 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'Your first visit should explain your current oral health, any urgent needs and the options available before you choose treatment.',
    takeaways: ['Bring medical details and questions.', 'The examination should be explained in plain language.', 'A written plan helps you decide calmly.'],
    sections: articleSections.firstAppointment,
    faqs: [
      ['Will treatment happen at the first visit?', 'Sometimes, but not always. Many first visits focus on examination, diagnosis and planning.'],
      ['Should I tell the dentist about medical problems?', 'Yes. Medical history and medication can affect dental treatment planning.'],
      ['Can I ask about costs before deciding?', 'Yes. Treatment options and estimated costs should be explained before you decide.']
    ],
    relatedTreatment: 'preventive'
  },
  {
    slug: 'filling-onlay-or-crown',
    category: 'Restorative dentistry',
    categorySlug: 'restorative',
    ...blogImages.restorative,
    title: 'Filling, onlay or crown: how dentists choose the right repair',
    metaTitle: 'Filling, Onlay or Crown: Choosing Tooth Repair | My Dentist',
    metaDescription:
      'Understand how tooth structure, cracks and bite forces affect whether a filling, onlay or crown is recommended.',
    summary: 'How remaining tooth structure, bite forces and fracture size affect the restoration recommended.',
    readTime: '7 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'The right repair depends on how much healthy tooth remains, how the tooth bites and whether the weakened parts need coverage.',
    takeaways: ['Bigger repairs need more protection.', 'Cracks change the decision.', 'Maintenance affects longevity.'],
    sections: articleSections.fillingOnlayOrCrown,
    faqs: [
      ['Is a crown stronger than a filling?', 'A crown can protect a weakened tooth better, but it is not automatically the right choice for every cavity.'],
      ['Can a filling become a crown later?', 'Yes. If a tooth weakens, cracks or loses more structure, a crown or onlay may be recommended later.'],
      ['Do onlays last forever?', 'No restoration lasts forever. Oral hygiene, bite forces and maintenance affect longevity.']
    ],
    relatedTreatment: 'restorative'
  },
  {
    slug: 'dental-implant-consultation',
    category: 'Dental implants',
    categorySlug: 'implants',
    ...blogImages.implants,
    title: 'What actually happens during a dental implant consultation?',
    metaTitle: 'Dental Implant Consultation: What Happens | My Dentist',
    metaDescription:
      'Learn what dentists assess before implant treatment, including health, gums, bone, alternatives and maintenance needs.',
    summary: 'The records, health checks and replacement alternatives discussed before implant surgery.',
    readTime: '7 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'An implant consultation checks whether implant treatment is suitable and compares it with other ways to replace the missing tooth.',
    takeaways: ['Health and gum stability matter.', 'Bone volume must be assessed.', 'Alternatives should be explained.'],
    sections: articleSections.implantConsultation,
    faqs: [
      ['Is implant surgery always possible?', 'No. Suitability depends on health, gum condition, bone volume and risk factors.'],
      ['Will I need a scan?', 'Some implant cases need advanced imaging to assess bone and plan the final tooth position.'],
      ['Are implants permanent?', 'Implants can last many years, but they still need maintenance and can develop complications.']
    ],
    relatedTreatment: 'implants'
  },
  {
    slug: 'child-first-dental-visit',
    category: 'Children\'s dentistry',
    categorySlug: 'children',
    ...blogImages.children,
    title: 'Making a child\'s first dental visit calm and useful',
    metaTitle: 'Child First Dental Visit: Calm Preparation | My Dentist',
    metaDescription:
      'Help your child prepare for a first dental visit with practical advice on timing, language, brushing and what the dentist may check.',
    summary: 'How parents can prepare, what the dentist may check and why an early visit should feel low pressure.',
    readTime: '5 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'A child\'s first dental visit should build confidence while helping parents understand brushing, diet and early prevention.',
    takeaways: ['Keep language simple and positive.', 'Early visits are often short and gentle.', 'Parents get prevention advice too.'],
    sections: articleSections.childFirstVisit,
    faqs: [
      ['What age should a child first see a dentist?', 'Usually when the first teeth appear or by around the first birthday.'],
      ['Should I say the dentist will not do anything?', 'Avoid promises you cannot control. Use simple, positive and honest language.'],
      ['Are baby teeth worth treating?', 'Yes. Baby teeth help chewing, speech, spacing and comfort.']
    ],
    relatedTreatment: 'children'
  },
  {
    slug: 'bleeding-gums',
    category: 'Gum health',
    categorySlug: 'preventive',
    ...blogImages.preventive,
    title: 'Bleeding gums: when better brushing is not the whole answer',
    metaTitle: 'Bleeding Gums: When to See a Dentist | My Dentist',
    metaDescription:
      'Understand common causes of bleeding gums, what a gum assessment measures and when professional dental support is appropriate.',
    summary: 'Common reasons gums bleed, what a gum assessment measures and when professional support is appropriate.',
    readTime: '6 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'Bleeding gums commonly mean inflammation, but persistent bleeding should be assessed so gum disease and risk factors are not missed.',
    takeaways: ['Do not ignore repeated gum bleeding.', 'A gum assessment measures more than plaque.', 'Home care and professional care often work together.'],
    sections: articleSections.bleedingGums,
    faqs: [
      ['Is bleeding when brushing normal?', 'No. It is common, but repeated bleeding suggests inflammation or another risk factor.'],
      ['Should I stop brushing bleeding gums?', 'No. Gentle, effective cleaning is important, but you should get advice if bleeding continues.'],
      ['Can gum disease be reversed?', 'Early inflammation can often improve, but advanced gum disease needs ongoing management.']
    ],
    relatedTreatment: 'preventive'
  },
  {
    slug: 'bonding-or-veneers',
    category: 'Cosmetic dentistry',
    categorySlug: 'cosmetic',
    ...blogImages.cosmetic,
    title: 'Composite bonding or veneers: questions to ask before choosing',
    metaTitle: 'Composite Bonding or Veneers: Questions to Ask | My Dentist',
    metaDescription:
      'Compare composite bonding and veneers using preparation, repairability, cost, maintenance and smile goals before cosmetic treatment.',
    summary: 'A balanced look at preparation, repairability, maintenance and when tooth alignment should come first.',
    readTime: '8 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'Bonding is often more conservative and repairable, while veneers can create larger changes but may need more preparation and maintenance planning.',
    takeaways: ['Ask how much tooth preparation is needed.', 'Consider alignment before reshaping teeth.', 'Plan future repair and replacement costs.'],
    sections: articleSections.bondingOrVeneers,
    faqs: [
      ['Is bonding cheaper than veneers?', 'Often, but cost should not be the only factor. Maintenance, lifespan and suitability matter.'],
      ['Do veneers last longer than bonding?', 'Porcelain veneers may resist stains and wear better, but they still need care and eventual replacement.'],
      ['Can bonding fix every smile concern?', 'No. Some concerns need orthodontics, whitening, gum care, veneers or restorative treatment.']
    ],
    relatedTreatment: 'cosmetic'
  },
  {
    slug: 'implant-or-bridge',
    category: 'Dental implants',
    categorySlug: 'implants',
    ...blogImages.implants,
    title: 'Dental implant or bridge: comparing two ways to replace a tooth',
    metaTitle: 'Dental Implant or Bridge: Compare Tooth Replacement | My Dentist',
    metaDescription:
      'Compare a dental implant and bridge for replacing a missing tooth, including supporting teeth, surgery, cleaning and maintenance.',
    summary: 'How supporting teeth, bone, cleaning access, surgery and maintenance change the decision.',
    readTime: '8 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'An implant avoids preparing adjacent teeth but involves surgery; a bridge can be faster but depends on the condition of neighbouring teeth.',
    takeaways: ['Adjacent tooth health matters.', 'Implants need sufficient bone and gum health.', 'Cleaning access affects long-term success.'],
    sections: articleSections.implantOrBridge,
    faqs: [
      ['Is an implant always better than a bridge?', 'No. Each option has advantages and limitations.'],
      ['Does a bridge damage nearby teeth?', 'A bridge usually requires shaping supporting teeth, which may be reasonable if those teeth already need crowns.'],
      ['Can I leave a missing tooth untreated?', 'Sometimes, but missing teeth can affect chewing, bite stability and nearby teeth. Ask your dentist about risks.']
    ],
    relatedTreatment: 'implants'
  },
  {
    slug: 'urgent-dental-care',
    category: 'Emergency care',
    categorySlug: 'emergency',
    ...blogImages.emergency,
    title: 'Is it a dental emergency? Symptoms that need prompt advice',
    metaTitle: 'Is It a Dental Emergency? Symptoms to Watch | My Dentist',
    metaDescription:
      'Know when toothache, swelling, trauma, bleeding or a broken tooth needs urgent dental advice or emergency medical care.',
    summary: 'A clear guide to severe pain, swelling, trauma, lost restorations and hospital warning signs.',
    readTime: '5 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'Severe pain, facial swelling, trauma, uncontrolled bleeding or signs of spreading infection need prompt dental or medical advice.',
    takeaways: ['Swelling can become serious.', 'Knocked-out adult teeth are time-sensitive.', 'Broken restorations should be assessed before damage worsens.'],
    sections: articleSections.urgentCare,
    faqs: [
      ['Is toothache always an emergency?', 'Not always, but severe, worsening or persistent toothache should be assessed.'],
      ['What should I do for a knocked-out adult tooth?', 'Call immediately. Handle the tooth by the crown, avoid scrubbing the root and follow urgent advice.'],
      ['Can antibiotics fix a dental abscess?', 'Antibiotics alone may not solve the source. Dental treatment is often needed.']
    ],
    relatedTreatment: 'emergency'
  },
  {
    slug: 'cracked-tooth-pain',
    category: 'Restorative dentistry',
    categorySlug: 'restorative',
    ...blogImages.restorative,
    title: 'Why a cracked tooth can hurt only when you bite',
    metaTitle: 'Cracked Tooth Pain When Biting | My Dentist',
    metaDescription:
      'Learn why cracked teeth can hurt on biting, how dentists assess cracks and why treatment ranges from monitoring to crowns.',
    summary: 'How cracks are assessed and why treatment ranges from monitoring and bonding to a crown or root canal care.',
    readTime: '6 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'A cracked tooth may hurt on biting because the crack flexes under pressure and irritates the nerve or supporting tissues.',
    takeaways: ['Symptoms can come and go.', 'Cracks are not always visible.', 'Early assessment can reduce fracture risk.'],
    sections: articleSections.crackedTooth,
    faqs: [
      ['Can a cracked tooth heal by itself?', 'No. Tooth cracks do not heal like bone. Some can be monitored, but others need protection.'],
      ['Will an X-ray always show a crack?', 'No. Some cracks are too fine or positioned in a way that makes them hard to see on X-rays.'],
      ['Does every cracked tooth need root canal treatment?', 'No. Treatment depends on crack depth, symptoms and nerve involvement.']
    ],
    relatedTreatment: 'restorative'
  },
  {
    slug: 'nervous-about-dentist',
    category: 'Patient guidance',
    categorySlug: 'patient',
    ...blogImages.firstVisit,
    title: 'Nervous about the dentist? Tell the clinic before you arrive',
    metaTitle: 'Nervous About the Dentist? Practical Help | My Dentist',
    metaDescription:
      'Practical ways nervous patients can make dental appointments more predictable, communicative and manageable.',
    summary: 'Small adjustments that can make appointments more predictable, communicative and manageable.',
    readTime: '5 min read',
    published: '2026-07-15',
    updated: '2026-07-15',
    answer:
      'If you are nervous, telling the dental clinic before the appointment helps the team adjust communication, pacing and breaks.',
    takeaways: ['Anxiety is common and worth mentioning.', 'Agreeing signals and pauses can help.', 'Clear explanations reduce uncertainty.'],
    sections: articleSections.nervous,
    faqs: [
      ['How do I tell the dentist I am scared?', 'Say it clearly when booking or at the start of the visit. The team can adjust communication and pacing.'],
      ['Can I ask the dentist to stop?', 'Yes. Agree a stop signal before treatment begins.'],
      ['Should I delay care until I feel less nervous?', 'Delaying can make some problems worse. A consultation can be a first step without pressure to start treatment immediately.']
    ],
    relatedTreatment: 'preventive'
  }
];

export const blogCategories = [
  { label: 'All', value: 'all' },
  { label: 'Preventive', value: 'preventive' },
  { label: 'Cosmetic', value: 'cosmetic' },
  { label: 'Restorative', value: 'restorative' },
  { label: 'Implants', value: 'implants' },
  { label: 'Children', value: 'children' },
  { label: 'Emergency', value: 'emergency' },
  { label: 'Patient guidance', value: 'patient' }
];

export const routePaths = [
  '/',
  '/gallery/',
  '/blog/',
  '/privacy-policy/',
  '/cookie-policy/',
  '/accessibility/',
  ...doctors.map((doctor) => `/dentists/${doctor.slug}/`),
  ...blogPosts.map((post) => `/blog/${post.slug}/`),
  ...treatments.map((treatment) => `/treatments/${treatment.slug}/`)
];

export function getTreatment(slug) {
  return treatments.find((treatment) => treatment.slug === slug);
}

export function getBlogPost(slug) {
  return blogPosts.find((post) => post.slug === slug);
}

export function getDoctor(slug) {
  return doctors.find((doctor) => doctor.slug === slug);
}
